import Loader from 'components/Loader';
import { useFormik } from 'formik';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import React from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';
import { GENDER, MODULE_TYPE } from 'utils/constants';
import { titleCaseIfExists } from 'utils/helper';
import * as Yup from 'yup';
import { HEATLHCARE_HEADERS } from '../helpers';
import AssetImageUploader from 'containers/blog/BlogList/components/AssetImageUploader';

const DoctorBasicDetails = ({ doctorId, doctorDetails }) => {
  const genderArray = Object.keys(GENDER)?.map((elem) => ({
    label: titleCaseIfExists(elem),
    value: GENDER[elem],
  }));

  const [updateDoctorRequest, { loading: updateDoctorLoading }] = useRequest({
    ...HEATLHCARE_HEADERS,
    url: `/healthcare/doctor/admin/${doctorId}`,
    method: 'PUT',
    onSuccess: () => {
      window.location.reload();
      toast.success('Success! Doctor has been updated.');
    },
    onError: (err) => {
      toast.error(err?.message);
      console.log(err);
    },
  });

  const getInitialValues = (details) => {
    return {
      salutation: !isEmpty(details) ? details?.salutation : '',
      firstName: !isEmpty(details) ? details?.firstName : '',
      lastName: !isEmpty(details) ? details?.lastName : '',
      gender: !isEmpty(details) ? details?.gender : '',
      email: !isEmpty(details) ? details?.email : '',
      phoneNumber: !isEmpty(details) ? details?.phoneNumber : '',
      degree: !isEmpty(details) ? details?.degree : '',
      experience: !isEmpty(details) ? details?.experience : '',
      experienceYear: !isEmpty(details) ? details?.experienceYear : '',
      bio: !isEmpty(details) ? details?.bio : '',
    };
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: !isEmpty(doctorDetails) ? getInitialValues(doctorDetails) : getInitialValues(),
    onSubmit: async (values) => {
      updateDoctorRequest({
        body: {
          ...values,
        },
      });
    },
    validationSchema: Yup.object().shape({
      firstName: Yup.string()
        .required('Please provide First name')
        .min(2, 'First name should be at least 2 characters long')
        .max(128, 'First name should be at most 128 characters long'),
      lastName: Yup.string()
        .required('Please provide Last name')
        .min(2, 'Last name should be at least 2 characters long')
        .max(128, 'Last name should be at most 128 characters long'),
      // email: Yup.string()
      //   .email()
      //   .required('Please provide email'),
      // phoneNumber: Yup.string()
      //   .matches(/^[1-9]\d{0,14}$/, 'Phone number must be up to 15 digits and positive')
      //   .required('Phone number is required'),
    }),
  });

  return (
    <>
      <Loader isActive={updateDoctorLoading} />
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <Col md={12}>
            <AssetImageUploader
              isAsset={false}
              forType={MODULE_TYPE.METADATA}
              formik={formik}
              fieldName={'profileImage'}
              label={'Select Profile Image'}
            />
          </Col>
        </Row>
        <Card className="mb-5">
          <CardBody>
            <Row className="align-items-center">
              <Col md={6}>
                <FormGroup className="mb-4">
                  <Label for="salutation" className="form-label  ">
                    Salutation
                  </Label>
                  <Input
                    id="salutation"
                    type="text"
                    className="form-control"
                    placeholder="Salutation..."
                    invalid={!!(formik.touched.salutation && formik.errors.salutation)}
                    {...formik.getFieldProps('salutation')}
                  />
                  <FormFeedback className="d-block">{formik.errors.salutation}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-4">
                  <Label for="firstName" className="form-label  ">
                    First Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="firstName"
                    type="text"
                    className="form-control"
                    placeholder="First Name..."
                    invalid={!!(formik.touched.firstName && formik.errors.firstName)}
                    {...formik.getFieldProps('firstName')}
                  />
                  <FormFeedback className="d-block">{formik.errors.firstName}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-4">
                  <Label for="lastName" className="form-label  ">
                    Last Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="lastName"
                    type="text"
                    className="form-control"
                    placeholder="Last Name..."
                    invalid={!!(formik.touched.lastName && formik.errors.lastName)}
                    {...formik.getFieldProps('lastName')}
                  />
                  <FormFeedback className="d-block">{formik.errors.lastName}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-4">
                  <Label for="gender" className="form-label">
                    Gender
                  </Label>
                  <Select
                    id="gender"
                    options={genderArray}
                    value={genderArray?.find((e) => e?.value === formik.values.gender)}
                    onChange={(obj) => formik.setFieldValue('gender', obj?.value)}
                  />

                  <FormFeedback className="d-block">{formik.errors.gender}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-4">
                  <Label for="email" className="form-label  ">
                    Email
                  </Label>
                  <Input
                    id="email"
                    type="text"
                    className="form-control"
                    placeholder="Email..."
                    invalid={!!(formik.touched.email && formik.errors.email)}
                    {...formik.getFieldProps('email')}
                  />
                  <FormFeedback className="d-block">{formik.errors.email}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-4">
                  <Label for="phoneNumber" className="form-label  ">
                    Phone Number
                  </Label>
                  <Input
                    id="phoneNumber"
                    type="number"
                    className="form-control"
                    placeholder="Phone Number..."
                    invalid={!!(formik.touched.phoneNumber && formik.errors.phoneNumber)}
                    {...formik.getFieldProps('phoneNumber')}
                  />
                  <FormFeedback className="d-block">{formik.errors.phoneNumber}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup className="mb-4">
                  <Label for="degree" className="form-label  ">
                    Degree
                  </Label>
                  <Input
                    id="degree"
                    type="text"
                    className="form-control"
                    placeholder="Degree..."
                    invalid={!!(formik.touched.degree && formik.errors.degree)}
                    {...formik.getFieldProps('degree')}
                  />
                  <FormFeedback className="d-block">{formik.errors.degree}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={9}>
                <FormGroup className="mb-4">
                  <Label for="experience" className="form-label  ">
                    Experience
                  </Label>
                  <Input
                    id="experience"
                    type="text"
                    className="form-control"
                    placeholder="Experience..."
                    invalid={!!(formik.touched.experience && formik.errors.experience)}
                    {...formik.getFieldProps('experience')}
                  />
                  <FormFeedback className="d-block">{formik.errors.experience}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="mb-4">
                  <Label for="experienceYear" className="form-label  ">
                    Experience Years
                  </Label>
                  <Input
                    id="experienceYear"
                    type="number"
                    className="form-control"
                    placeholder="Experience Years..."
                    invalid={!!(formik.touched.experienceYear && formik.errors.experienceYear)}
                    {...formik.getFieldProps('experienceYear')}
                  />
                  <FormFeedback className="d-block">{formik.errors.experienceYear}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={12}>
                <FormGroup className="mb-4">
                  <Label for="bio" className="form-label  ">
                    Bio
                  </Label>
                  <Input
                    id="bio"
                    type="textarea"
                    rows={6}
                    className="form-control"
                    placeholder="Bio..."
                    invalid={!!(formik.touched.bio && formik.errors.bio)}
                    {...formik.getFieldProps('bio')}
                  />
                  <FormFeedback className="d-block">{formik.errors.bio}</FormFeedback>
                </FormGroup>
              </Col>
            </Row>

            <div className="mt-5">
              <Button type="submit" color="primary">
                Update Doctor
              </Button>
            </div>
          </CardBody>
        </Card>
      </Form>
    </>
  );
};

export default DoctorBasicDetails;
